// extracted by mini-css-extract-plugin
module.exports = {"container":"post-module--container--1x29O","content":"post-module--content--qcwgF"};